var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuritySafeInit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9401 7.41288C13.9401 10.6729 11.5734 13.7262 8.34007 14.6195C8.12007 14.6795 7.88005 14.6795 7.66005 14.6195C4.42672 13.7262 2.06006 10.6729 2.06006 7.41288V4.4862C2.06006 3.93953 2.4734 3.31954 2.98673 3.11287L6.70005 1.59289C7.53339 1.25289 8.47339 1.25289 9.30672 1.59289L13.0201 3.11287C13.5267 3.31954 13.9467 3.93953 13.9467 4.4862L13.9401 7.41288Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99996 8.33268C8.73634 8.33268 9.33329 7.73573 9.33329 6.99935C9.33329 6.26297 8.73634 5.66602 7.99996 5.66602C7.26358 5.66602 6.66663 6.26297 6.66663 6.99935C6.66663 7.73573 7.26358 8.33268 7.99996 8.33268Z",
    fill: "#213B98",
    stroke: "#213B98",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.33203V10.332",
    stroke: "#213B98",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySafeInit);
export default __webpack_public_path__ + "static/media/security-safe-init.541021e1264d982be235499790e56ce5.svg";
export { ForwardRef as ReactComponent };